const colors = {
  black: '#000000',
  white: '#FFFFFF',

  primary: {
    50: '#F4FCFF',
    100: '#CBFDFE',
    300: '#63E3F9',
    500: '#00A9EB',
    700: '#0062A9',
    900: '#003270'
  },

  secondary: {
    100: '#E3E6FE',
    500: '#727CF5',
    300: '#ABB2FC'
  },

  tertiary: '#2A3E60',

  whiteAlpha: {
    50: 'rgba(255, 255, 255, 0.04)',
    100: 'rgba(255, 255, 255, 0.06)',
    200: 'rgba(255, 255, 255, 0.08)',
    300: 'rgba(255, 255, 255, 0.16)',
    400: 'rgba(255, 255, 255, 0.24)',
    500: 'rgba(255, 255, 255, 0.36)',
    600: 'rgba(255, 255, 255, 0.48)',
    700: 'rgba(255, 255, 255, 0.64)',
    800: 'rgba(255, 255, 255, 0.80)',
    900: 'rgba(255, 255, 255, 0.92)'
  },

  blackAlpha: {
    50: 'rgba(0, 0, 0, 0.04)',
    100: 'rgba(0, 0, 0, 0.06)',
    200: 'rgba(0, 0, 0, 0.08)',
    300: 'rgba(0, 0, 0, 0.16)',
    400: 'rgba(0, 0, 0, 0.24)',
    500: 'rgba(0, 0, 0, 0.36)',
    600: 'rgba(0, 0, 0, 0.48)',
    700: 'rgba(0, 0, 0, 0.64)',
    800: 'rgba(0, 0, 0, 0.80)',
    900: 'rgba(0, 0, 0, 0.92)'
  },

  gray: {
    50: '#F7FAFC',
    100: '#EDF2F7',
    200: '#E2E8F0',
    300: '#CBD5E0',
    400: '#A0AEC0',
    500: '#718096',
    600: '#4A5568',
    700: '#2D3748',
    800: '#1A202C',
    900: '#171923'
  },

  blue: {
    50: '#F0F3FF',
    100: '#DAE1FF',
    300: '#91A3FF',
    500: '#4962FF',
    700: '#2434B7',
    900: '#0E167A'
  },

  red: {
    50: '#FFF5F5',
    100: '#FED7D8',
    300: '#FFA58A',
    500: '#FF4A3D',
    700: '#B71E2D',
    900: '#7A0B28'
  },

  yellow: {
    50: '#FFFBEB',
    100: '#FFF4CC',
    300: '#FFD466',
    500: '#FFA500',
    700: '#B76900',
    900: '#7A3D00'
  },

  green: {
    50: '#FBFEF7',
    100: '#E9FACF',
    300: '#A8E46E',
    500: '#4CA817',
    700: '#26780B',
    900: '#0D5004'
  },

  orange: {
    50: '#FFFAF0',
    100: '#FEEBC8',
    300: '#F6AD55',
    500: '#DD6B20',
    700: '#9C4221',
    900: '#652B19'
  },

  teal: {
    50: '#E6FFFA',
    100: '#B2F5EA',
    300: '#4FD1C5',
    500: '#319795',
    700: '#285E61',
    900: '#1D4044'
  },

  cyan: {
    50: '#EDFDFD',
    100: '#C4F1F9',
    300: '#76E4F7',
    500: '#00B5D8',
    700: '#0987A0',
    900: '#065666'
  },

  purple: {
    50: '#FAF5FF',
    100: '#E9D8FD',
    300: '#B794F4',
    500: '#805AD5',
    700: '#553C9A',
    900: '#322659'
  },

  pink: {
    50: '#FFF5F7',
    100: '#FED7E2',
    300: '#F687B3',
    500: '#D53F8C',
    700: '#97266D',
    900: '#521B41'
  }
}

export default colors
